/**
 * This file is just to use mitt as an application wide event bus
 * https://github.com/developit/mitt
 * Example came from:
 * https://serversideup.net/vue-3-web-notification-component/
 * 
 * To be used it should be imported into the files that either need
 * to listen or emit events like (updating the path accordingly):
 * `import { EventBus } from './../composables/EventBus.js';``
 */

!function (e, n) { "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = e || self).mitt = n() }(this, function () { return function (e) { return { all: e = e || new Map, on: function (n, t) { var f = e.get(n); f ? f.push(t) : e.set(n, [t]) }, off: function (n, t) { var f = e.get(n); f && (t ? f.splice(f.indexOf(t) >>> 0, 1) : e.set(n, [])) }, emit: function (n, t) { var f = e.get(n); f && f.slice().map(function (e) { e(t) }), (f = e.get("*")) && f.slice().map(function (e) { e(n, t) }) } } } });

export const EventBus = mitt();